import type React from 'react';
import styled, { useTheme } from 'styled-components';
import Typography from 'app/ui/components/atoms/typography';
import { useConceptBackground } from 'app/hooks/use-concept-background';
import { Link } from 'react-router-dom';

export type CardChallengeProps = {
  conceptName: string;
  concept?: { name?: string } | null;
  challengeId: string;
};

const Container = styled.div<{ $gradient: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 80px;
  border-radius: 0.5rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  &:hover {
    outline: 1px solid ${({ theme }) => theme.colors.focoltone};
  }
  ${({ theme: { spacing }, $gradient }) => `
    padding: ${spacing(3)};
    background: ${$gradient};
  `}
  ${({ theme: { media, spacing } }) => `${media.large(
    () => `
        height: 120px;
        padding: ${spacing(5)};
      `,
  )}
  `}
`;

const ImageBackground = styled.div<{ $backgroundImage: string }>`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 90px;
  height: 90px;
  background-image: url(${({ $backgroundImage }) => $backgroundImage});
  background-size: contain;
  background-position: 40px;
  background-repeat: no-repeat;
  pointer-events: none;
  ${({ theme: { media } }) => `${media.large(
    () => `
        width: 150px;
        height: 150px;
      `,
  )}
  `}
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
  max-width: 70%;
  position: relative;
  z-index: 1;
`;

const CardChallenge: React.FC<CardChallengeProps> = ({ conceptName, concept, challengeId }) => {
  const theme = useTheme();
  const { gradient, imageUrl } = useConceptBackground(concept);

  return (
    <Link to={`/library/challenges/${challengeId}`}>
      <Container $gradient={gradient}>
        <ImageBackground $backgroundImage={imageUrl} />
        <ContentWrapper>
          <Typography variant="h5" color={theme.colors.white}>
            {conceptName}
          </Typography>
        </ContentWrapper>
      </Container>
    </Link>
  );
};

export default CardChallenge;
